import React from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import {IntlProvider} from "react-intl";

import {HistoryRouter} from "redux-first-history/rr6";
import {history, store} from "./store";
import Routes from "routes/routes";
import arDictionary from "./locales/ar";
import enDictionary from "./locales/en";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from "hooks/ScrollToTop";
import {setupAuthorizationInterceptor} from "services/root.api";
import {logoutAction} from "services/logout/logout.action";

const APPDictionary = {
  ar: arDictionary,
  en: enDictionary
};

let lang = localStorage.getItem("lang");
if (!lang) {
  localStorage.setItem("lang", "en");
  lang = localStorage.getItem("lang");
}

const container = document.getElementById("root");
const root = createRoot(container);

const {dispatch} = store;
setupAuthorizationInterceptor(() => {
  dispatch(logoutAction())
})

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <IntlProvider messages={APPDictionary[lang]} locale={lang} defaultLocale="en">
          <ScrollToTop/>
          <Routes/>
        </IntlProvider>
      </HistoryRouter>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
